/* ─────────────────────────────────────────
   FORTA COSMETICS — LOGO CAROUSEL
   Wipe-in image carousel for footer logo "O"
   Replaces framer-motion clip-path animation
───────────────────────────────────────── */
(function () {
  function initLogoCarousel() {
    var carousel = document.getElementById('logo-carousel');
    if (!carousel) return;

    var under = carousel.querySelector('.logo-carousel__img--under');
    var over  = carousel.querySelector('.logo-carousel__img--over');
    var sources = carousel.dataset.sources ? JSON.parse(carousel.dataset.sources) : [];
    if (sources.length < 2 || !under || !over) return;

    var index = 0;

    // Initialise: under shows last image, over wipes in first image
    under.src = sources[sources.length - 1];
    over.src = sources[0];
    over.classList.add('is-visible');

    setInterval(function () {
      var prev = index;
      index = (index + 1) % sources.length;

      // 1. Set "under" to the currently visible image
      under.src = sources[prev];

      // 2. Reset "over" to start position (offscreen right) instantly
      over.style.transition = 'none';
      over.classList.remove('is-visible');

      // 3. Wait one frame for the reset to paint, then animate the wipe-in
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          over.src = sources[index];
          over.style.transition = '';
          over.classList.add('is-visible');
        });
      });
    }, 2000);
  }

  document.addEventListener('DOMContentLoaded', initLogoCarousel);
})();
